import { useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import { dispatch, getState } from "../../../state/store";
import { selectAppTypes } from "../../../state/selectors";
import {
  resetConsentElements,
  setAppsRefresh,
  setBreadcrumbsRedirectUrl,
  setIsDuplicate,
  setIsViewOnly,
  setSelectedConsent
} from "../../../state/ducks";

import { appUserService, t } from "../../../services";
import { appTypesNames, appUserRoles, routePaths, strCode } from "../../../consts";

import { BreadcrumbContainer } from "../styled";
import { LinkStyled } from "../../NavLink/styled";

const AppsBreadcrumb = ({
  slashBefore = false,
  slashAfter = false,
  onClick,
  isSameConsentData
}) => {
  const userApps = selectAppTypes()(getState());
  const history = useHistory();

  const isOneAppTypeOnly = useMemo(() => {
    return userApps?.length === 2 && userApps?.some((type) => type === appTypesNames.allApps);
  }, [userApps]);

  const isDisable = useMemo(() => {
    const roles = appUserService.getRoles();

    return (
      (!roles.includes(appUserRoles.Admin) &&
        history.location.pathname.startsWith(routePaths.APPS) &&
        isOneAppTypeOnly) ||
      (!isSameConsentData &&
        history.location.pathname.includes(routePaths.CONSENT_ELEMENT_CREATE)) ||
      history.location.pathname.includes(routePaths.CONSENT_ELEMENT_EDIT)
    );
  }, [userApps]);

  const resetConsentsData = () => {
    dispatch(setSelectedConsent(null));
    dispatch(resetConsentElements());
    dispatch(setIsDuplicate(false));
    dispatch(setIsViewOnly(false));

    dispatch(setAppsRefresh(true));
  };

  return (
    <LinkStyled
      as={isSameConsentData ? Link : "button"}
      to={routePaths.APPS}
      onClick={() => {
        if (isSameConsentData) {
          resetConsentsData();
        } else {
          dispatch(setBreadcrumbsRedirectUrl(routePaths.APPS));
          onClick && onClick();
        }
      }}
      disabled={isDisable}>
      <BreadcrumbContainer slashBefore={slashBefore} slashAfter={slashAfter}>
        {t(strCode.APPS_NAV_BTN)}
      </BreadcrumbContainer>
    </LinkStyled>
  );
};

AppsBreadcrumb.propTypes = {
  slashBefore: PropTypes.bool,
  slashAfter: PropTypes.bool,
  isSameConsentData: PropTypes.bool,
  onClick: PropTypes.func
};

export default AppsBreadcrumb;
